module.exports = __webpack_public_path__ + "img/stock2.7a74e2e2.png";